import { render, staticRenderFns } from "./LookupCodeDetail.vue?vue&type=template&id=9bfa7dbc&scoped=true"
import script from "./LookupCodeDetail.vue?vue&type=script&lang=js"
export * from "./LookupCodeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bfa7dbc",
  null
  
)

export default component.exports